<template>

  <div class="mt-2 mb-3">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <span class="medium-text">{{ simulationCharge.name }}</span>
        <trash-icon class="main-red-color trashIcon ml-2" size="16" @click="removeSimulationCharge"/>
      </div>
    </div>

    <div class="row mt-2">

      <div class="col-md-4">
        <b-input-group>
          <b-form-input
              id="prixTTC-input"
              v-model="simulationCharge.prixTTC"
              v-disable-scroll
              :placeholder="$t('simulationCharge.PrixTTC')"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue">
          </b-form-input>
          <b-input-group-append>{{ $t('euros.prixTTC') }}</b-input-group-append>
        </b-input-group>
      </div>

    </div>

  </div>

</template>

<script>

export default {

  name: "SimulationChargeComponent",

  components: {},

  props: {
    simulationCharge: {
      type: Object,
      default: null
    },
  },

  emits: ['removedSimulationCharge', 'didChangeValue'],

  methods: {

    removeSimulationCharge() {
      this.$emit('removedSimulationCharge', this.simulationCharge)
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/SimulationChargeComponent.vue